import React from 'react';
import { useIntl } from 'react-intl';

import QuizStudentWrapper, { QUIZ_STUDENT_THEME } from '../__wrapper/quiz-student__wrapper';
import { UI_KIT_HEADER_TYPOGRAPHY } from '../../constants';
import { H2, H3 } from '../../header-text/header-text';
import Image from '../../image/image';

interface Props {
    countCorrectAnswers: number;
    name: string;
}

const QuizStudentFinisher = (props: Props) => {
    const { countCorrectAnswers, name } = props;
    const intl = useIntl();

    return (
        <QuizStudentWrapper name={name} theme={QUIZ_STUDENT_THEME.FINISH}>
            <div className="quiz-student__section">
                <Image
                    alt="answer_status"
                    className="quiz-student__finish-image"
                    disableSrcSet={true}
                    src={intl.formatMessage({ id: 'quiz.finish.new.image.1x' })}
                />
                <H2
                    id="quiz.finish.title"
                    mix="quiz-student__section-title"
                    typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}
                />
                <H3 id="quiz.finish.result" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSRegular} />
                <div className="quiz-student__correct-answers-count">
                    <H3 typography={UI_KIT_HEADER_TYPOGRAPHY.headlineLMedium}>{countCorrectAnswers}</H3>
                </div>
            </div>
        </QuizStudentWrapper>
    );
};

export default QuizStudentFinisher;
